import postPath from './postPath';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';

const THREAD_FRAGMENT = gql(`
  fragment commentThreadPath_thread on ThreadFields {
    id
    resolvedAt
    post {
      ...postPath_post
    }
  }
`);

const commentThreadPath = (thread: DocumentType<typeof THREAD_FRAGMENT>) =>
  thread.post
    ? `${postPath(thread.post)}${thread.resolvedAt ? '/comments' : ''}#thread-${
        thread.id
      }`
    : undefined;

export default commentThreadPath;
